module.exports = __webpack_public_path__ + "img/11.e04220e5.png";